import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Col } from '../../components/Col';
import NewAutoCompleteField from '../../components/NewAutoCompleteField/NewAutoCompleteField';
import {
  contratosInitialState,
  CONTRATOS_FILTER_COOD_COOP,
  CONTRATOS_FILTER_ID_ESTADO,
  CONTRATOS_FILTER_NOM_CIDADE,
} from '../../pages/Contratos/Fluxos/Contratos';
import {
  loadCidadesByEstadoId,
  loadEstados,
} from '../../store/modules/LogradouroActions';
import styles from './FiltrosListagemContratoEntePublico.scss';
const rootClassName = styles.rootClassName;

const INITIAL_STATE = {
  filters: null,
  emptyEstados: null,
  emptyCidades: null,
};
class FiltrosListagemContratoEntePublico extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...INITIAL_STATE,
      filters: this.props.filters,
      emptyEstados: {
        cpf: contratosInitialState.filters[CONTRATOS_FILTER_ID_ESTADO],
        nome: this.props.languageValues.allEstados,
      },
      emptyCidades: {
        cpf: contratosInitialState.filters[CONTRATOS_FILTER_NOM_CIDADE],
        nome: this.props.languageValues.allCidades,
      },
      estado: 0,
      cidade: '',
    };
  }

  UNSAFE_componentWillMount() {
    this.loadEstados();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let needLoadEstados = false;
    let needLoadCidades = false;
    if (
      nextProps.filters[CONTRATOS_FILTER_COOD_COOP] !==
      this.state.filters[CONTRATOS_FILTER_COOD_COOP]
    ) {
      needLoadEstados = true;
    }
    if (
      nextProps.filters[CONTRATOS_FILTER_ID_ESTADO] !==
      this.state.filters[CONTRATOS_FILTER_ID_ESTADO]
    ) {
      needLoadCidades = true;
    }
    this.setState(
      {
        filters: { ...nextProps.filters },
      },
      () => {
        if (needLoadEstados) {
          this.loadEstados();
        }
        if (needLoadCidades) {
          this.loadCidades();
        }
      }
    );
  }

  hasCoopSelected = () => {
    return this.props.filters[CONTRATOS_FILTER_COOD_COOP] !==
      contratosInitialState.filters[CONTRATOS_FILTER_COOD_COOP]
      ? true
      : false;
  };
  
  getUFByIdEstado = (idEstado) => {
    const estados = this.props.logradouro.estados.filter(estado => estado.id === idEstado);
    return (estados && estados.length > 0) ? estados[0].sigla : '';
  };

  onLoadedEstados = () => {
    this.loadCidades();
  };

  loadEstados = () => {
    this.props.loadEstados(this.onLoadedEstados);
  };

  loadCidades = () => {
    const idEstado = this.props.filters[CONTRATOS_FILTER_ID_ESTADO];
    let uf;
    if (
      idEstado !== contratosInitialState.filters[CONTRATOS_FILTER_ID_ESTADO]
    ) {
      uf = this.getUFByIdEstado(idEstado).toLowerCase();
      this.props.loadCidadesByEstadoId(idEstado, uf);
    }
  };

  getEstados = () => {
    const estados = this.props.logradouro.estados;
    if (estados.length > 0) {
      return [{ ...this.state.emptyEstados }, ...estados];
    }
    return [];
  };

  estadosIsLoading = () => {
    return this.hasCoopSelected()
      ? this.props.logradouro.loadingAllEstadosByCoops
      : this.props.logradouro.loadingEstados;
  };

  estadosPlaceholder = () => {
    if (this.estadosIsLoading()) {
      return this.props.languageValues.loadingEstados;
    }
    return this.getEstados().length > 0
      ? this.props.languageValues.allEstados
      : this.props.languageValues.nenhumEstadoCarregado;
  };

  getCidades = () => {
    const uf = this.getUFByIdEstado(
      this.props.filters[CONTRATOS_FILTER_ID_ESTADO]
    ).toLowerCase();
    const cidades = this.props.logradouro.cidades[uf] || [];
    if (cidades.length > 0) {
      return [{ ...this.state.emptyCidades }, ...cidades];
    }
    return [];
  };

  cidadesIsLoading = () => {
    return this.props.logradouro.loadingCidades;
  };

  cidadesPlaceholder = () => {
    if (this.cidadesIsLoading()) {
      return this.props.languageValues.loadingCidades;
    }
    return this.getCidades().length > 0
      ? this.props.languageValues.allCidades
      : this.props.languageValues.nenhumaCidadeCarregada;
  };

  cidadesIsDisabled = () => {
    return (
      this.cidadesIsLoading() ||
      this.props.filters[CONTRATOS_FILTER_ID_ESTADO] ===
        contratosInitialState.filters[CONTRATOS_FILTER_ID_ESTADO]
    );
  };

  render() {
    return (
      <>
        <Col cols={[12, 12, 6, 6, 6]}>
          <NewAutoCompleteField
            label={this.props.languageValues.contratoEstados}
            className={rootClassName + '-estados-filter'}
            inputClassName={rootClassName + '-estados-input-filter'}
            placeholder={this.estadosPlaceholder()}
            options={this.getEstados().map((item) => {
              return {
                label: item.nome,
                value: item.id,
              };
            })}
            value={this.props.filters[CONTRATOS_FILTER_ID_ESTADO]}
            onChange={(value) => {
              if (
                value &&
                value.value !== this.props.filters[CONTRATOS_FILTER_ID_ESTADO]
              ) {
                this.props.changeValues({
                  [CONTRATOS_FILTER_ID_ESTADO]: value.value,
                });
              } else {
                this.props.changeValues({
                  [CONTRATOS_FILTER_ID_ESTADO]:
                    contratosInitialState.filters[CONTRATOS_FILTER_ID_ESTADO],
                });
              }
            }}
            disabled={this.props.loading || this.estadosIsLoading()}
            loading={this.estadosIsLoading()}
          />
        </Col>
        <Col cols={[12, 12, 6, 6, 6]}>
          <NewAutoCompleteField
            label={this.props.languageValues.contratoCidades}
            className={rootClassName + '-cidades-filter'}
            inputClassName={rootClassName + '-cidades-input-filter'}
            placeholder={this.cidadesPlaceholder()}
            options={this.getCidades().map((cidade) => {
              return {
                label: cidade.nome,
                value: cidade.nome,
              };
            })}
            value={this.props.filters[CONTRATOS_FILTER_NOM_CIDADE]}
            onChange={(value) => {
              if (
                value &&
                value.value !== this.props.filters[CONTRATOS_FILTER_NOM_CIDADE]
              ) {
                if (value.value === this.props.languageValues.allCidades) {
                  this.props.changeValues({
                    [CONTRATOS_FILTER_NOM_CIDADE]: '',
                  });
                } else {
                  this.props.changeValues({
                    [CONTRATOS_FILTER_NOM_CIDADE]: value.value,
                  });
                }
              } else {
                this.props.changeValues({
                  [CONTRATOS_FILTER_NOM_CIDADE]:
                    contratosInitialState.filters[CONTRATOS_FILTER_NOM_CIDADE],
                });
              }
            }}
            disabled={this.props.loading || this.cidadesIsDisabled()}
            loading={this.cidadesIsLoading()}
            loadingMessage={this.props.languageValues.loadingCidades}
          />
        </Col>
      </>
    );
  }
}

FiltrosListagemContratoEntePublico.propTypes = {
  loading: PropTypes.bool,
  filters: PropTypes.object.isRequired,
  changeValues: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  logradouro: state.logradouro,
  contratos: state.contratos,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadEstados,
      loadCidadesByEstadoId,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FiltrosListagemContratoEntePublico);
